import React, { useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMugSaucer } from '@fortawesome/free-solid-svg-icons'
import { CSSTransition } from 'react-transition-group'
import styles from './Menu.module.scss'

interface MenuProps {
  isMenuOpen: boolean
}
const Menu: React.FC<MenuProps> = ({ isMenuOpen }) => {
  const menuRef = useRef<HTMLDivElement>(null)

  return (
    <div className={styles.menu}>
      <>
        {isMenuOpen && <div className={styles.overlay}></div>}
        <CSSTransition
          in={isMenuOpen}
          timeout={300}
          classNames={{
            enter: styles.menuItemsEnter,
            enterActive: styles.menuItemsEnterActive,
            exit: styles.menuItemsExit,
            exitActive: styles.menuItemsExitActive,
          }}
          nodeRef={menuRef}
          unmountOnExit
        >
          <div
            ref={menuRef}
            className={`${styles.menuItems} ${
              isMenuOpen ? styles.menuItemsOpen : ''
            }`}
          >
            <div className={styles.menuItem}>
              <a
                className={styles.support}
                href="https://www.buymeacoffee.com/languageguessr"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faMugSaucer} />
                <p>Support this project!</p>
              </a>
            </div>
          </div>
        </CSSTransition>
      </>
    </div>
  )
}

export default Menu
